module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Vuks er feil-norming.c20c7672.mp3";